module.exports = __webpack_public_path__ + "img/chayot_yes.b8275282.png";